import { ValueOf } from '@xhgj/xh-jsutils'
import { customCreateEnum } from './enumArray'

/**
 * 落地商签订方式枚举
 */
const signingTypeList = [
  { label: '纸质合同', value: '1' },
  { label: '全电子合同', value: '2' },
  { label: '我方电子对方纸质合同', value: '3' },
] as const

export type SigningType = ValueOf<typeof signingTypeList>
export const signingTypeEnum = customCreateEnum(signingTypeList)

/**
 * 签署状态枚举
 */
const signatureStatusList = [
  { label: '双方已签署', value: '1' },
  { label: '未签署', value: '2' },
  { label: '我方已签署', value: '3' },
] as const

export type SignatureStatus = ValueOf<typeof signatureStatusList>
export const signatureStatusEnum = customCreateEnum(signatureStatusList)

/**
 * e签宝流程状态枚举
 */
const eSignProcessStatusList = [
  { label: '待发起', value: '0' },
  { label: '签署中', value: '1' },
  { label: '签署失败', value: '2' },
  { label: '已完成', value: '3' },
] as const

export type ESignProcessStatus = ValueOf<typeof eSignProcessStatusList>
export const eSignProcessStatusEnum = customCreateEnum(eSignProcessStatusList)

const fileReviewStateList = [
  {
    label: '无效',
    value: '1',
  },
  {
    label: '审批中',
    value: '2',
  },
  {
    label: '未通过',
    value: '3',
  },
  {
    label: '合同附件',
    value: '4',
  },
] as const
export const fileReviewStateEnum = customCreateEnum(fileReviewStateList)
import { ValueOf } from '@xhgj/xh-jsutils'
import { customCreateEnum } from './enumArray'

/**
 * 落地商签订方式枚举
 */
const signingTypeList = [
  { label: '纸质合同', value: '1' },
  { label: '全电子合同', value: '2' },
  { label: '我方电子对方纸质合同', value: '3' },
] as const

export type SigningType = ValueOf<typeof signingTypeList>
export const signingTypeEnum = customCreateEnum(signingTypeList)

/**
 * 签署状态枚举
 */
const signatureStatusList = [
  { label: '双方已签署', value: '1' },
  { label: '未签署', value: '2' },
  { label: '我方已签署', value: '3' },
] as const

export type SignatureStatus = ValueOf<typeof signatureStatusList>
export const signatureStatusEnum = customCreateEnum(signatureStatusList)

/**
 * e签宝流程状态枚举
 */
const eSignProcessStatusList = [
  { label: '待发起', value: '0' },
  { label: '签署中', value: '1' },
  { label: '签署失败', value: '2' },
  { label: '已完成', value: '3' },
] as const

export type ESignProcessStatus = ValueOf<typeof eSignProcessStatusList>
export const eSignProcessStatusEnum = customCreateEnum(eSignProcessStatusList)

const fileReviewStateList = [
  {
    label: '无效',
    value: '1',
  },
  {
    label: '审批中',
    value: '2',
  },
  {
    label: '未通过',
    value: '3',
  },
  {
    label: '合同附件',
    value: '4',
  },
] as const
export const fileReviewStateEnum = customCreateEnum(fileReviewStateList)
